export default __webpack_public_path__ + "static/media/BNB.281b02d9.svg";